<template>
  <Modal
    title="Edit Person"
    ref="modal"
    size="xs"
  >
    <q-input
      v-model="label"
      label="Person Name"
      outlined
      autofocus
      @keyup.enter="canSave && save()"
    />

    <template v-slot:actions>
      <q-btn
        flat
        label="Cancel"
        @click="hide()"
      />
      <async-btn
        label="Save"
        color="primary"
        :task="task"
        :disabled="!canSave"
        @click="save"
      />
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin, ModalMixin } from '@/mixins';
import { Person } from '@/analysis/types';
import { Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { update } from './person';

interface Data {
  person: Person | null;
  label: string;
}

export default defineComponent({
  emits: ['updated'],
  mixins: [HasTaskMixin, ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  data(): Data {
    return {
      person: null,
      label: '',
    };
  },
  computed: {
    canSave(): boolean {
      return this.label.trim() !== '' && this.label !== (this.person ? this.person.label : null);
    },
  },
  methods: {
    open(person: Person) {
      this.person = person;
      this.label = person.label || '';
      (this.$refs.modal as ModalElement).show();
    },
    save() {
      if (!this.person) return;

      this.task = update(this.person.id, {
        label: this.label.trim(),
      });
      this.task.then((person: Person) => {
        this.$emit('updated', person);
        (this.$refs.modal as ModalElement).hide();
        notify('Person updated.');
      });
    },
  },
});
</script>
